// @ts-strict-ignore
import { Box } from 'components/Box';
import { TrackedPrimaryButtonLink } from 'components/Button';
import { Flex } from 'components/Flex';
import { Hero } from 'components/Hero';
import { RichTextHeadline } from 'components/Text/RichTextHeadline';
import {
  CmsApiCtaHeroBlockData,
  CmsApiCtaHeroBlockLayout,
} from 'modules/cms/api/types/CmsApiCtaHero';

type Props = {
  data: CmsApiCtaHeroBlockData;
  isPageHeader?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function CmsCtaHeroBlock({
  data: { buttonText, buttonUrl, text, image, withOverlay, layout },
  isPageHeader,
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Hero
      withOverlay={withOverlay}
      heroImage={image}
      imageHeight={200}
      data-qa-id="call-to-action-hero"
      minHeight={
        {
          [CmsApiCtaHeroBlockLayout.STANDARD]: [
            null,
            null,
            null,
            'calc(100vh - 300px)',
          ],
          [CmsApiCtaHeroBlockLayout.COMPACT]: [null, null, null, 170],
        }[layout]
      }
      py={
        {
          [CmsApiCtaHeroBlockLayout.STANDARD]: 96,
          [CmsApiCtaHeroBlockLayout.COMPACT]: 32,
        }[layout]
      }
      mb={
        {
          [CmsApiCtaHeroBlockLayout.COMPACT]: 32,
        }[layout]
      }
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <RichTextHeadline
          color="white"
          textAlign="center"
          tag={isPageHeader ? 'h1' : undefined}
          styleAs={isPageHeader ? 'h2' : undefined}
          $reverseUnderline
        >
          {text}
        </RichTextHeadline>
      </Box>
      <Flex>
        {buttonUrl && buttonText && (
          <TrackedPrimaryButtonLink
            href={buttonUrl}
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Call to Action Hero',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated,
            }}
          >
            {buttonText}
          </TrackedPrimaryButtonLink>
        )}
      </Flex>
    </Hero>
  );
}
